module.exports = __webpack_public_path__ + "img/badge_rimborsi_int.b43aff4d.jpg";